export default __webpack_public_path__ + "static/media/benefits4mx.114017b7.png";